/// <reference path="../../../ts/libs.ts" />
import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { EncryptContent } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export enum EncryptionActionType {
  encryptExtracts = 'encryptExtracts',
  decryptExtracts = 'decryptExtracts'
}

export interface EncryptContentAction extends Action {
  contentArray: IContentInfo[];
  encryptionActionType: EncryptionActionType;
}

export function encryptContent(contentArray: IContentInfo[], encryptionActionType: EncryptionActionType): EncryptContentAction {
  return {
    type: EncryptContent,
    contentArray: contentArray,
    encryptionActionType: encryptionActionType
  };
}

export const isEncryptContentAction = isActionFactory<EncryptContentAction>(EncryptContent);
